var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIosApple({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24",
    id: "ios-apple",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.949 23.876c-.733 0-1.386-.248-2.015-.484-.539-.205-1.047-.397-1.529-.397-.428 0-.916.183-1.433.375-.625.231-1.333.496-2.102.496-1.264 0-2.397-.724-3.469-2.209-.045-.063-4.409-6.472-2.289-11.231C4.273 7.82 5.946 6.497 8.084 6.497c1.128 0 2.169.354 3.005.639.468.159.91.309 1.143.309.275 0 .717-.161 1.182-.334.776-.285 1.744-.642 2.854-.642 1.609 0 3.065.743 4.453 2.271a.506.506 0 0 1 .127.387.509.509 0 0 1-.203.353c-1.463 1.066-2.205 2.299-2.205 3.666 0 1.693.836 2.937 2.791 4.154a.497.497 0 0 1 .192.628c-1.838 4.112-3.526 5.948-5.474 5.948zM12.279 6.211c-.12 0-.241-.008-.36-.022a.497.497 0 0 1-.438-.477c-.132-3.346 2.704-5.395 4.8-5.585a.505.505 0 0 1 .539.409c.231 1.288-.201 2.704-1.188 3.884-.938 1.122-2.192 1.791-3.353 1.791z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosApple);
export default __webpack_public_path__ + "static/media/ios-apple.b0396e449db5f81a9b8ff5e6d9766e13.svg";
export { ForwardRef as ReactComponent };